export const RESERVED_SUBDOMAINS = Object.freeze(['learn', 'www', 'assessments']);

export function isReservedSubdomain(subdomain) {
  return RESERVED_SUBDOMAINS.includes(String(subdomain || '').toLowerCase());
}

export function isOrganizationSubdomain(subdomain) {
  return Boolean(subdomain) && !isReservedSubdomain(subdomain);
}

export function getSubdomainFromHost(hostname) {
  if (!hostname) return null;
  // Strip port if present
  const host = hostname.split(':')[0];
  // Expected: subdomain.astra-xr.com
  const parts = host.split('.');
  if (parts.length < 3) return null; // e.g., astra-xr.com or localhost
  const [sub] = parts;
  if (!sub || sub === 'www') return null;
  return sub;
}

// Validates subdomain exists in Supabase organizations table.
// Returns { ok: boolean, name?: string }
export async function isAllowedSubdomain(sub, supabase) {
  try {
    if (!sub) return { ok: false };
    const { data, error } = await supabase
      .from('organizations')
      .select('name')
      .eq('subdomain', sub)
      .maybeSingle();
    if (error) return { ok: false };
    return { ok: !!data, name: data?.name };
  } catch {
    return { ok: false };
  }
}


